import useFirebaseNotifications from "../hooks/useFirebaseNotifications";

export default function NotificationsListener() {
  useFirebaseNotifications();
  return null;
}
